import type { AuthTokenResponse, UserResponse } from '@acme/api';
import { useEffect, useState } from 'react';
import type { OrganizationResponse } from '../baseUserStore';
import { useUserStoreContext } from './userStoreContext';

interface UseUser {
  getAuth: () => boolean;
  user: UserResponse | null;
  organization: OrganizationResponse | null;
  isLoading: boolean;
  setToken: () => void;
  login: (tokenResponse: AuthTokenResponse) => void;
  logout: () => void;
  fetch: () => void;
  tokenInstaled: boolean;
}

export const useUser = (): UseUser => {
  const userStore = useUserStoreContext();

  const [user, setUser] = useState<UserResponse | null>(userStore.user);
  const [organization, setOrganization] = useState<OrganizationResponse | null>(
    userStore.organization
  );
  const [isLoading, setIsLoading] = useState<boolean>(userStore.isLoading);
  const [tokenInstaled, setTokenInstaled] = useState<boolean>(
    userStore.tokenInstaled
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setUser(userStore.user);
      setOrganization(userStore.organization);
      setIsLoading(userStore.isLoading);
      setTokenInstaled(userStore.tokenInstaled);
    }, 200);
    return () => clearInterval(interval);
  }, [userStore]);

  return {
    getAuth: userStore.getAuth.bind(userStore),
    user,
    organization,
    isLoading,
    setToken: userStore.setToken.bind(userStore),
    login: userStore.login.bind(userStore),
    logout: userStore.logout.bind(userStore),
    tokenInstaled,
    fetch: userStore.fetchUser.bind(userStore),
  };
};
